import { Check } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import theme from "../../../theme/theme";

interface Props {
  text: string;
  isSender?: boolean;
}

function MessageChatCard({ text, isSender }: Props) {
  return (
    <Box
      mb={2}
      sx={{
        backgroundColor: isSender ? theme.colors.primary : "#E7FFE7",
        borderRadius: 2,
        p: 1,
        maxWidth: 400,
      }}
    >
      <Typography color={isSender ? "#fff" : "#000"}>{text}</Typography>
      <Stack
        direction={"row"}
        mt={1}
        alignItems="flex-end"
        justifyContent={"flex-end"}
      >
        <Typography color={isSender ? "#fff" : "#000"} mr={1} fontSize={13}>
          19:14
        </Typography>
        {isSender ? (
          <Check htmlColor={theme.colors.white} fontSize="small" />
        ) : null}
      </Stack>
    </Box>
  );
}

export default MessageChatCard;
